module.exports = __webpack_public_path__ + "media/images/preguntas-frecuentes-a09fee6cc0b8c692f6e8aedae3709ffa.png";